const copyButton = document.querySelector('[data-copy-url]')

copyButton.addEventListener('click', () => {
  const url = copyButton.getAttribute('data-copy-url')

  const copyElement = document.createElement('textarea')
  document.body.appendChild(copyElement)
  copyElement.value = url
  copyElement.select()
  document.execCommand('copy')
  document.body.removeChild(copyElement)
})
